<template>
  <div class="container-fluid">
    <p class="page-headliner">
      Showing {{ notificationList.length }} notifications |
      {{ getNotificationsCount() }} unread
    </p>
    <div class="notifications">
      <div v-if="notificationList.length == 0">You have 0 Notifications</div>
      <div
        class="notification"
        v-for="(notify, index) in notificationList"
        :key="index"
      >
        <div class="content-type" @click="readMessage(notify.id)">
          <p class="read-status" :class="{ unread: notify.read === false }"></p>
          <div class="icon-box">
            <span class="material-icons"> event </span>
          </div>
        </div>
        <div class="content-details" @click="readMessage(notify.id)">
          <p class="date">{{ notify.date }}</p>
          <p class="message">{{ notify.message }}</p>
          <p class="action">{{ notify.action }}</p>
        </div>
        <span
          class="material-icons close-button"
          @click="deleteNotification(notify.id)"
        >
          close
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "notifications",
  computed: {
    ...mapGetters(["getUserSession", "getUserNotifications"])
  },
  data() {
    return {
      notificationList: [
        {
          id: 0,
          read: false,
          deleted: false,
          type: "warning",
          alertLevel: "high",
          date: "November 5, 2021",
          message:
            "You have 7 days left to renew your subscription for Device 416814 before it is shut down",
          action: ""
        }
      ]
    };
  },
  methods: {
    readMessage(id) {
      const item = this.notificationList.find(x => x.id == id);
      item.read = true;
      const HTTP = this.$httpUtils.NotificationHTTP;
      HTTP.patch(`notification/${id}`)
        .then(res => {
          this.$store.commit("saveUserNotifications", this.notificationList);
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getNotificationsCount() {
      return this.notificationList.filter(item => item.read != true).length;
    },
    // deleteNotification(index) {
    //   let newList = [];
    //   newList = this.notificationList.filter(
    //     item => this.notificationList.indexOf(item) !== index
    //   );
    //   this.notificationList = newList;
    // },
    deleteNotification(id) {
      const res = confirm("Are you sure you want to delete this notification?");
      if (!res) return;

      this.notificationList = this.notificationList.filter(x => x.id != id);

      const HTTP = this.$httpUtils.NotificationHTTP;
      HTTP.delete(`notification/${id}`)
        .then(res => {
          // remove deleted item from list
          this.$store.commit("saveUserNotifications", this.notificationList);
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    fecthData() {
      this.notificationList = this.getUserNotifications.map(item => ({
        ...item,
        id: item.id,
        read: false,
        deleted: false,
        type: item.type,
        alertLevel: item.alertLevel,
        date: moment(item.createdAt).fromNow(),
        message: item.longMessage,
        action: ""
      }));
    }
  },
  mounted() {
    // fetch data
    this.fecthData();
  }
};
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
}

.container-fluid {
  padding-top: 2rem;
}

.page-headliner {
  color: #5f5f5f;
  font-size: 13px;
}

.notifications {
  margin-top: 3rem;
}

.notification {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem 1rem;
  background: #ebebeb;
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
  position: relative;
}

.content-type {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.read-status {
  width: 10px;
  height: 10px;
  background: #b8b8b8;
  /* border: 2px solid #5F5F5F; */
  margin-right: 1rem;
  border-radius: 50%;
}

.unread {
  background: #d95040;
  /* background: #14c047; */
}

.icon-box {
  width: 50px;
  height: 50px;
  background: rgb(26, 147, 202);
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  margin-right: 1.5rem;
}

.content-details {
  color: #5f5f5f;
}

.content-details .message {
  margin-bottom: 1rem;
}

.content-details .date {
  font-size: 1rem;
}

.content-details .action {
  color: rgb(26, 147, 202);
  /* color: #D95040; */
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
}

.close-button {
  color: #d95040;
  font-size: 1.2rem;
  cursor: pointer;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  padding: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/notifications/index.vue